// extracted by mini-css-extract-plugin
module.exports = {"container":"DoneCounter_container__3go0O","title":"DoneCounter_title__3lZP6","doneText":"DoneCounter_doneText__1_TKv"};